import { Button, Dialog, Typography } from '@mui/material'
import { Stack } from '@mui/system'
import React, { useState } from 'react'
import { useAppNavigate } from '../../Paths'
import NewSiteDialog from '../DataCollection/components/NewSiteDialog'
import NewEventDialog from '../Event/NewEventDialog'
import UsersEditPage from '../Users/UsersEditPage'

export default function AdminDashboard() {
  const [modalOpen, setModalOpen] = useState(false)
  const [newSiteOpen, setNewSiteOpen] = useState(false)
  const [newEventOpen, setNewEventOpen] = useState(false)
  const appNavigate = useAppNavigate()

  const handleModalClose = () => {
    setModalOpen(false)
  }

  const handleNewSiteDialogClose = () => {
    setNewSiteOpen(false)
  }

  return (
    <Stack p={2} spacing={2}>
      <Stack direction={'row'} spacing={2}>
        <Typography fontWeight={'bold'} variant="h5" width={50}>
          Users
        </Typography>
        <Button
          variant="contained"
          onClick={() => {
            setModalOpen(true)
          }}
        >
          Add user
        </Button>
        <Button variant="contained" onClick={() => appNavigate.admin.toUsers()}>
          View users
        </Button>
      </Stack>

      <Stack direction={'row'} spacing={2}>
        <Typography fontWeight={'bold'} variant="h5" width={50}>
          Site
        </Typography>
        <Button variant="contained" onClick={() => setNewSiteOpen(true)}>
          Add a site
        </Button>
        <Button variant="contained" onClick={() => setNewEventOpen(true)}>
          Add new event
        </Button>
      </Stack>
      <Dialog open={modalOpen} onClose={handleModalClose}>
        <UsersEditPage userId={''} onClose={handleModalClose} />
      </Dialog>
      <NewSiteDialog open={newSiteOpen} onClose={handleNewSiteDialogClose} />
      <NewEventDialog
        open={newEventOpen}
        onClose={() => setNewEventOpen(false)}
      />
    </Stack>
  )
}
